import { render, staticRenderFns } from "./DownloadBase64FileButton.vue?vue&type=template&id=45e5ee8a&scoped=true&"
import script from "./DownloadBase64FileButton.vue?vue&type=script&lang=ts&"
export * from "./DownloadBase64FileButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e5ee8a",
  null
  
)

export default component.exports